import React, { useState, useEffect } from "react";
import "./VistaUsuarios.css";
import DetalleRediseno from "./DetalleRediseno";
import FiltroMenu from "./FiltroMenu";

const convertirFechaMySQL = (fecha) => {
  if (!fecha) return null;
  if (fecha instanceof Date) return fecha;
  if (typeof fecha !== "string") return null;
  const fechaLimpia = fecha.trim();
  if (!fechaLimpia) return null;
  const resultado = new Date(fechaLimpia.replace(" ", "T"));
  return isNaN(resultado.getTime()) ? null : resultado;
};

const formatearFechaLegible = (fechaStr) => {
  const fecha = convertirFechaMySQL(fechaStr);
  if (!fecha) return "";
  const d = String(fecha.getDate()).padStart(2, "0");
  const m = String(fecha.getMonth() + 1).padStart(2, "0");
  const y = fecha.getFullYear();
  const h = String(fecha.getHours()).padStart(2, "0");
  const min = String(fecha.getMinutes()).padStart(2, "0");
  return `${d}/${m}/${y} ${h}:${min}`;
};
const vipEstaVigente = (user) => {
  const fecha = convertirFechaMySQL(user?.fecha_vencimiento_plan);

  if (!fecha) return false;

  return user?.tipo_plan === "vip_30dias" && fecha.getTime() > Date.now();
};
const topEstaVigente = (user) => {
  const fecha = convertirFechaMySQL(user?.fecha_vencimiento_top);
  if (!fecha) return false;
  return fecha.getTime() > Date.now();
};

const destacadoEstaVigente = (user) => {
  const fecha = convertirFechaMySQL(user?.fecha_vencimiento_destacado);
  if (!fecha) return false;
  return fecha.getTime() > Date.now();
};

const superTopEstaVigente = (user) => {
  const fecha = convertirFechaMySQL(user?.fecha_vencimiento_super_top);
  if (!fecha) return false;
  return fecha.getTime() > Date.now();
};

const obtenerUrlFoto = (foto) => {
  const def = "https://micontenidohot.com/uploads/default.jpg";
  if (!foto || typeof foto !== "string") return def;
  const fotoLimpia = foto.trim();
  if (!fotoLimpia) return def;
  if (fotoLimpia.startsWith("http://") || fotoLimpia.startsWith("https://"))
    return fotoLimpia;
  return `https://micontenidohot.com/${fotoLimpia}`;
};

function TarjetaUsuario({ user, alSeleccionar, onPendiente }) {
  const [fotoIndex, setFotoIndex] = useState(0);
  const [pausado, setPausado] = useState(false);

  const fotos =
    Array.isArray(user?.fotos) && user.fotos.length > 0
      ? user.fotos
      : user?.photo_url || user?.imagen
      ? [user.photo_url || user.imagen]
      : ["https://micontenidohot.com/uploads/default.jpg"];

  useEffect(() => {
    if (fotos.length <= 1 || pausado) return;

    const delayInicial = Math.floor(Math.random() * 5000);

    let intervalo;

    const timeout = setTimeout(() => {
      intervalo = setInterval(() => {
        setFotoIndex((prev) => (prev + 1) % fotos.length);
      }, 5000);
    }, delayInicial);

    return () => {
      clearTimeout(timeout);
      clearInterval(intervalo);
    };
  }, [fotos.length, pausado]);

  const cambiarFoto = (e, direccion) => {
    e.stopPropagation();
    if (direccion === "siguiente") {
      setFotoIndex((prev) => (prev < fotos.length - 1 ? prev + 1 : 0));
    } else if (direccion === "anterior") {
      setFotoIndex((prev) => (prev > 0 ? prev - 1 : fotos.length - 1));
    }
  };

  const obtenerTiempoRestante = (fechaFin) => {
    if (!fechaFin) return "";

    const ahora = new Date();
    const fin = convertirFechaMySQL(fechaFin);
    if (!fin) return "";

    const diferencia = fin.getTime() - ahora.getTime();

    if (diferencia <= 0) {
      return "Finalizado";
    }

    const horas = Math.floor(diferencia / (1000 * 60 * 60));
    const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));

    return `${horas}h ${minutos}m restantes`;
  };

  const tiempoRestanteSuperTop = obtenerTiempoRestante(
    user.fecha_vencimiento_super_top
  );

  const fotoActual =
    fotos[fotoIndex] ||
    fotos[0] ||
    "https://micontenidohot.com/uploads/default.jpg";
  const urlFotoActual = obtenerUrlFoto(fotoActual);

  const esVIP = user.es_vip === true;
  const esSuperTopVigente = user.es_super_top === true;
  const esDestacadoVigente = user.es_destacado === true;
  const esTopVigente = user.es_top === true;

  return (
    <div
      className="user-card-item"
      onMouseEnter={() => setPausado(true)}
      onMouseLeave={() => setPausado(false)}
      onClick={() => {
        if (user.status === "pendiente") {
          onPendiente();
          return;
        }
        alSeleccionar(user);
      }}
      style={{
        position: "relative",
        borderRadius: "16px",
        overflow: "hidden",
        cursor: "pointer",
        aspectRatio: "3/4",
      }}
    >
      {/* SUPER TOP ELITE */}
      {esSuperTopVigente && (
        <div
          style={{
            position: "absolute",
            top: "8px",
            left: "8px",
            right: "8px",
            zIndex: 50,
            background:
              "linear-gradient(90deg, #dc2626 0%, #e11d48 50%, #f43f5e 100%)",
            color: "#fff",
            padding: "6px 12px",
            borderRadius: "999px",
            fontSize: "0.60rem",
            fontWeight: "900",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            letterSpacing: "1px",
            border: "1px solid rgba(255,255,255,0.25)",
            boxShadow:
              "0 0 15px rgba(244,63,94,.45), 0 4px 15px rgba(0,0,0,.35)",
            backdropFilter: "blur(6px)",
          }}
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
          </svg>
          TOP X 24 HORAS
        </div>
      )}
      {/* Insignia VIP Premium */}
      {esVIP && !esSuperTopVigente && (
        <div
          style={{
            position: "absolute",
            top: "16px",
            right: "-42px",
            width: "150px",
            transform: "rotate(45deg)",
            background:
              "linear-gradient(135deg, #9333ea 0%, #7e22ce 50%, #6b21a8 100%)",
            color: "#fff",
            fontSize: "0.58rem",
            fontWeight: "800",
            textAlign: "center",
            padding: "3px 0",
            zIndex: 40,
            boxShadow: "0 2px 8px rgba(0,0,0,0.35)",
            borderTop: "1px solid rgba(255,255,255,0.25)",
            borderBottom: "1px solid rgba(255,255,255,0.25)",
            letterSpacing: "1px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "4px",
            pointerEvents: "none",
          }}
        >
          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
            <path d="M5 17h14l-1.2 4H6.2L5 17zm13.2-10 2.8 2-3 6H6l-3-6 2.8-2L9 11l3-7 3 7 3.2-4z" />
          </svg>
          VIP
        </div>
      )}
      {/* Insignia DESTACADO Premium */}
      {esDestacadoVigente && !esVIP && !esSuperTopVigente && (
        <div
          style={{
            position: "absolute",
            top: "16px",
            right: "-42px",
            width: "150px",
            transform: "rotate(45deg)",
            background:
              "linear-gradient(135deg, #fbbf24 0%, #f59e0b 50%, #d97706 100%)",
            color: "#fff",
            fontSize: "0.58rem",
            fontWeight: "800",
            textAlign: "center",
            padding: "3px 0",
            zIndex: 25,
            boxShadow: "0 2px 8px rgba(0,0,0,0.35)",
            borderTop: "1px solid rgba(255,255,255,0.25)",
            borderBottom: "1px solid rgba(255,255,255,0.25)",
            letterSpacing: "1px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "4px",
            pointerEvents: "none",
          }}
        >
          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l2.8 5.7L21 8.6l-4.5 4.4 1.1 6.3L12 16.8l-5.6 2.9 1.1-6.3L3 8.6l6.2-.9L12 2z" />
          </svg>
          DESTACADO
        </div>
      )}

      {esTopVigente && !esVIP && !esDestacadoVigente && !esSuperTopVigente && (
        <div style={{}}></div>
      )}
      <img
        key={urlFotoActual}
        src={urlFotoActual}
        alt={user.nic || user.name || user.nombre || "Perfil"}
        onError={(e) => {
          if (
            e.currentTarget.src !==
            "https://micontenidohot.com/uploads/default.jpg"
          ) {
            e.currentTarget.src =
              "https://micontenidohot.com/uploads/default.jpg";
          }
        }}
        className="user-card-photo"
      />

      {/* Las flechas de cambio de foto se eliminaron por completo aquí */}

      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.05) 40%, rgba(0,0,0,0.85) 80%, rgba(0,0,0,0.95) 100%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "12px",
          color: "#ffffff",
          pointerEvents: "none",
        }}
      >
        <div style={{ pointerEvents: "auto" }}>
          <span
            style={{
              background: "rgba(0, 0, 0, 0.55)",
              backdropFilter: "blur(6px)",
              padding: "4px 10px",
              borderRadius: "20px",
              fontSize: "0.72rem",
              fontWeight: "600",
              color: "#ffffff",
              display: "inline-flex",
              alignItems: "center",
              gap: "4px",
              border: "1px solid rgba(255,255,255,0.2)",
            }}
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="#e11d48"
              style={{ display: "block" }}
            >
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
            </svg>
            {user.location || user.ubicacion || "Sin ubicación"}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            pointerEvents: "auto",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontSize: "1.1rem",
              fontWeight: "800",
              color: "#ffffff",
            }}
          >
            {user.nic || user.name || user.nombre || "Sin nombre"},{" "}
            <span style={{ color: "#f43f5e", fontWeight: "800" }}>
              {user.age || user.edad || ""}
            </span>
          </h3>

          <p
            style={{
              margin: 0,
              fontSize: "0.72rem",
              color: "#cbd5e1",
              fontWeight: "500",
            }}
          >
            Estatura: {user.height || user.estatura || "1.65 m"}
          </p>

          <p
            style={{
              margin: 0,
              fontSize: "0.72rem",
              color: "#cbd5e1",
              fontWeight: "500",
            }}
          >
            Cuerpo:{" "}
            {user.body_type ||
              user.cuerpo ||
              user.tipo_cuerpo ||
              "No especificado"}
          </p>

          <div
            style={{
              display: "flex",
              gap: "6px",
              flexWrap: "nowrap",
              justifyContent: "flex-start",
              marginTop: "2px",
              width: "100%",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}

function VistaUsuarios({ alVolver, alSeleccionarUsuario }) {
  const [usuarios, setUsuarios] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const [mostrarModalPendiente, setMostrarModalPendiente] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hoverVolver, setHoverVolver] = useState(false);
  const [hoverHamburguesa, setHoverHamburguesa] = useState(false);
  const [filtrosAplicados, setFiltrosAplicados] = useState({
    edadMin: 18,
    edadMax: 50,
    pais: "Bolivia",
    departamento: "Todos",
  });

  useEffect(() => {
    const obtenerUsuarios = async () => {
      try {
        const res = await fetch(
          "https://micontenidohot.com/obtener_anuncios.php"
        );
        const data = await res.json();
        if (data.success) {
          setUsuarios(data.anuncios || []);
        } else {
          setUsuarios([]);
        }
      } catch (error) {
        console.error("Error obteniendo usuarios:", error);
        setUsuarios([]);
      } finally {
        setCargando(false);
      }
    };
    obtenerUsuarios();
  }, []);

  const handleAplicarFiltros = (nuevosFiltros) => {
    setFiltrosAplicados(nuevosFiltros);
  };

  const usuariosFiltrados = usuarios
    .filter((user) => {
      if (user.status !== "activo") return false;

      const edad = Number(user.edad || user.age || 0);
      const ubi = (user.location || user.ubicacion || "").toLowerCase();

      const paisFiltro = filtrosAplicados.pais || "Bolivia";
      const depFiltro = filtrosAplicados.departamento || "Todos";

      const cumpleEdad =
        edad >= filtrosAplicados.edadMin && edad <= filtrosAplicados.edadMax;

      let cumpleUbicacion = false;

      if (paisFiltro === "Bolivia") {
        cumpleUbicacion =
          depFiltro === "Todos" || ubi.includes(depFiltro.toLowerCase());
      } else {
        cumpleUbicacion = true;
      }

      return cumpleEdad && cumpleUbicacion;
    })
    .sort((a, b) => {
      const superTopA = superTopEstaVigente(a);
      const superTopB = superTopEstaVigente(b);
      if (superTopA && !superTopB) return -1;
      if (!superTopA && superTopB) return 1;

      const vipA = vipEstaVigente(a);
      const vipB = vipEstaVigente(b);
      if (vipA && !vipB) return -1;
      if (!vipA && vipB) return 1;

      const destA = destacadoEstaVigente(a);
      const destB = destacadoEstaVigente(b);
      if (destA && !destB) return -1;
      if (!destA && destB) return 1;

      const topA = topEstaVigente(a);
      const topB = topEstaVigente(b);
      if (topA && !topB) return -1;
      if (!topA && topB) return 1;

      return Number(b.id) - Number(a.id);
    });

  // CÓDIGO CORREGIDO:
  const usuariosTop7Dias = usuarios.filter(
    (user) =>
      user.status === "activo" && (topEstaVigente(user) || vipEstaVigente(user))
  );

  if (usuarioSeleccionado) {
    return (
      <DetalleRediseno
        usuario={usuarioSeleccionado}
        alVolver={() => setUsuarioSeleccionado(null)}
      />
    );
  }

  if (cargando) {
    return (
      <div className="grid-page-wrapper">
        <p className="grid-loading-text">Cargando catálogo de usuarios...</p>
      </div>
    );
  }

  return (
    <div className="grid-page-wrapper">
      {/* 1. ELIMINAR EL BOTÓN ☰ FIXED DE AQUÍ */}

      <FiltroMenu
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        onAplicarFiltros={handleAplicarFiltros}
      />

      {/* 2. REEMPLAZAR LA SECCIÓN DEL CARRUSEL AQUÍ */}
      {usuariosTop7Dias.length > 0 && (
        <div className="top-carrusel-section">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
            <div className="top-carrusel-title" style={{ margin: 0, padding: 0 }}>Usuarios TOP</div>
            
            {/* Botón hamburguesa dentro de la cabecera sticky */}
            <button
              onClick={() => setIsMenuOpen(true)}
              onMouseEnter={() => setHoverHamburguesa(true)}
              onMouseLeave={() => setHoverHamburguesa(false)}
              title="Menú / Filtros"
              style={{
                backgroundColor: hoverHamburguesa
                  ? "rgba(30, 41, 59, 0.95)"
                  : "rgba(30, 41, 59, 0.75)",
                color: "#ffffff",
                border: "1px solid rgba(255, 255, 255, 0.15)",
                backdropFilter: "blur(8px)",
                borderRadius: "50%",
                width: "38px",
                height: "38px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.1rem",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                transition: "all 0.25s ease",
                transform: hoverHamburguesa ? "rotate(90deg) scale(1.05)" : "rotate(0deg) scale(1)",
              }}
            >
              ☰
            </button>
          </div>

          <div className="top-carrusel-container">
            {usuariosTop7Dias.map((user) => {
              const fotoPerfil =
                Array.isArray(user.fotos) && user.fotos.length > 0
                  ? user.fotos[0]
                  : user.photo_url || user.imagen || "";
              const urlFinal = obtenerUrlFoto(fotoPerfil);
              return (
                <div
                  key={`top-${user.id}`}
                  className="top-carrusel-item"
                  onClick={() => {
                    if (user.status === "pendiente") {
                      setMostrarModalPendiente(true);
                      return;
                    }
                    setUsuarioSeleccionado(user);
                    if (alSeleccionarUsuario) alSeleccionarUsuario(user);
                  }}
                >
                  <div className="top-carrusel-avatar-wrapper">
                    <img
                      src={urlFinal}
                      alt={user.nic || user.name || user.nombre || "Perfil"}
                      className="top-carrusel-avatar"
                      onError={(e) => {
                        e.currentTarget.src = "https://micontenidohot.com/default.jpg";
                      }}
                    />
                  </div>
                  <span className="top-carrusel-name">
                    {user.nic || user.name || user.nombre || "Perfil"}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
   

      {usuariosFiltrados.length === 0 ? (
        <div className="grid-empty">
          No hay perfiles disponibles con los filtros seleccionados.
        </div>
      ) : (
        <div className="users-two-columns-grid">
          {usuariosFiltrados.map((user) => (
            <TarjetaUsuario
              key={user.id}
              user={user}
              alSeleccionar={(u) => {
                setUsuarioSeleccionado(u);
                if (alSeleccionarUsuario) alSeleccionarUsuario(u);
              }}
              onPendiente={() => setMostrarModalPendiente(true)}
            />
          ))}
        </div>
      )}
      {/* BOTÓN FLOTANTE VOLVER */}
      {/* BOTÓN FLOTANTE VOLVER CON EFECTO ONDA */}
      <button onClick={alVolver} className="btn-flotante-volver">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>

      {mostrarModalPendiente && (
        <div
          className="modal-overlay"
          onClick={() => setMostrarModalPendiente(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.75)",
            backdropFilter: "blur(6px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            padding: "20px",
          }}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#0f172a",
              border: "1px solid #334155",
              maxWidth: "420px",
              width: "100%",
              borderRadius: "20px",
              padding: "28px",
              textAlign: "center",
              boxShadow: "0 20px 25px -5px rgba(0,0,0,0.5)",
              color: "#ffffff",
            }}
          >
            <div
              style={{
                width: "64px",
                height: "64px",
                borderRadius: "50%",
                backgroundColor: "rgba(245,158,11,0.12)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px auto",
                border: "1px solid rgba(245,158,11,0.25)",
              }}
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#f59e0b"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 22h14" />
                <path d="M5 2h14" />
                <path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22" />
                <path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2" />
              </svg>
            </div>
            <h3
              style={{
                color: "#ffffff",
                fontSize: "1.25rem",
                fontWeight: "800",
                marginBottom: "10px",
              }}
            >
              Anuncio en Revisión
            </h3>
            <p
              style={{
                color: "#94a3b8",
                fontSize: "0.9rem",
                lineHeight: "1.5",
                marginBottom: "24px",
              }}
            >
              El anuncio o el pago del anuncio está siendo revisado por el
              equipo de{" "}
              <span
                style={{
                  color: "#ffffff",
                  textDecoration: "underline",
                  fontWeight: "700",
                }}
              >
                passionysexo.com
              </span>
            </p>
            <button
              onClick={() => setMostrarModalPendiente(false)}
              style={{
                width: "100%",
                backgroundColor: "#e11d48",
                color: "#ffffff",
                border: "none",
                padding: "12px",
                borderRadius: "12px",
                fontWeight: "700",
                cursor: "pointer",
                fontSize: "0.95rem",
              }}
            >
              Entendido
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default VistaUsuarios;
